export default __webpack_public_path__ + "static/media/goopter-disinfection-robot-hospital-use-case.def365ce.jpg";